export default __webpack_public_path__ + "static/media/sr.a5bfd8fd.svg";